import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';

declare global {
  interface HTMLElementTagNameMap {
    'lele-roadmap': LeleRoadmap;
  }
}

@customElement('lele-roadmap')
export class LeleRoadmap extends DeesElement {
  public static demo = () => html`<lele-roadmap></lele-roadmap>`;
  public render (): TemplateResult {
    return html`
      <style>
        :host {
          background:${this.goBright ? '#eeeeeb' : '#212121'};
          font-family: 'Roboto', sans-serif;
          display: block;
          color: ${this.goBright ? '#333' : '#fff'};
        }

        .topspacer {
          height: 50px;
        }

        .bottomspacer {
          height: 30px;
        }

        .bottomspot {
          margin: auto;
          background: #e4002b;
          height: 11px;
          width: 11px;
          border-radius: 10px;
        }

        .maincontainer {
          position: relative;
          min-height: 300px;
          
          display: grid;
          grid-template-columns: calc(50% + 1px) calc(50% - 1px);
        }

        .line {
          border-right: 1px solid #e4002b;
        }

        .content {}

        .milestone {
          margin-top: 50px;
        }

        .milestone:first-child {
          margin-top: -10px;
        }

        .milestoneLabel {
          box-sizing: border-box;
          width: 100%;
          text-align: right;
          margin-left: -100%;
          padding-right: 20px;
          
        }

        .milestoneDot {
          background: #e4002b;
          height: 11px;
          width: 11px;
          border-radius: 10px;
          margin-top: -14px;
          margin-left: -6px;
        }

        .achievements {
          box-sizing: border-box;
          padding-left: 20px;
          margin-top: -30px;
        }

        .achievements .item {
          width: 275px;
          padding: 12px;
          background: ${this.goBright ? '#fff' : '#2a2a2a'};
          box-shadow: ${this.goBright ? '0px 0px 5px 0px rgba(0,0,0,0.1)' : 'none'}; 
          border-radius: 3px;
          margin-bottom: 10px;
          transition: all 0.2s;
        }

        .achievements .item:hover {
          background: #333333;
          box-shadow: 0px 3px 7px rgba(0,0,0,0.2);
        }
      </style>
      <div class="topspacer"></div>
      <div class="maincontainer">
        <div class="line"></div>
        <div class="content">
          <div class="milestone">
            <div class="milestoneLabel">
              MileStone v1
            </div>
            <div class="milestoneDot"></div>
            <div class="achievements">
              <div class="item">so cool</div>
              <div class="item">awesome</div>
              <div class="item">wow</div>
            </div>
          </div>
          <div class="milestone">
            <div class="milestoneLabel">
              MileStone v2
            </div>
            <div class="milestoneDot"></div>
            <div class="achievements">
              <div class="item">so cool</div>
              <div class="item">awesome</div>
              <div class="item">wow</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottomspacer">
        <div class="bottomspot"></div>
      </div>
    `;
  }
}